import React from 'react';
import { Box, Typography, Container, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import CookieConsent from "./cookies/CookieConsent";

const menuItems = [
    { label: "Why Digital Clone?", to: "#why-digital-clone" },
    { label: "Case Studies", to: "#case-studies" },
    { label: "Integration", to: "#integration" },
    { label: "Prices", to: "#pricing" }
];

const socialIcons = [
    { icon: '/images/home/facebook-icon.png', alt: 'Facebook', link: 'https://www.facebook.com/story.php/?story_fbid=974989504627985&id=100063508332609&_rdr' },
    { icon: '/images/home/instagram-icon.png', alt: 'Instagram', link: 'https://www.instagram.com/digital.eternity/' },
    { icon: '/images/home/youtube-icon.png', alt: 'YouTube', link: 'https://www.youtube.com/@eternity-ac' }
];

export default function Footer() {
    return (
        <>
            <Box sx={{ bgcolor: '#313131', color: 'white', py: { xs: 4, md: 6 } }}>
                <Container maxWidth="lg">
                    <Grid container spacing={{ xs: 3, md: 4 }} alignItems="flex-start">
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography
                                variant="h4"
                                fontWeight="bold"
                                sx={{
                                    fontSize: { xs: '24px', md: '32px' },
                                    textAlign: { xs: 'center', md: 'left' },
                                    mb: { xs: 3, md: 2 }
                                }}
                            >
                                MeetMyBot
                            </Typography>
                        </Grid>

                        <Grid size={{ xs: 12, md: 8 }}>
                            <Stack
                                direction={{ xs: 'column', sm: 'row' }}
                                spacing={{ xs: 2, sm: 3, md: 4 }}
                                justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
                                alignItems={{ xs: 'flex-start', md: 'center' }}
                                sx={{ flexWrap: 'wrap' }}
                            >
                                {menuItems.map((item) => (
                                    <Typography
                                        key={item.label}
                                        component="a"
                                        href={item.to}
                                        sx={{
                                            color: 'white',
                                            textDecoration: 'none',
                                            fontSize: { xs: '14px', md: '16px' },
                                            fontWeight: 400,
                                            '&:hover': {
                                                color: '#cbd5e1',
                                                textDecoration: 'underline'
                                            },
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                ))}
                            </Stack>

                            <Box sx={{
                                mt: { xs: 3, md: 3 },
                                textAlign: { xs: 'left', md: 'right' }
                            }}>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        fontSize: { xs: '14px', md: '16px' },
                                        fontWeight: 500,
                                        mb: { xs: 2, md: 0 },
                                        display: { xs: 'block', md: 'inline-block' },
                                        mr: { xs: 0, md: 2 }
                                    }}
                                >
                                    Join our community
                                </Typography>
                                <Stack
                                    direction="row"
                                    spacing={2}
                                    justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
                                    alignItems="center"
                                    sx={{ display: { xs: 'flex', md: 'inline-flex' } }}
                                >
                                    {socialIcons.map((social) => (
                                        <Box
                                            key={social.alt}
                                            component="a"
                                            href={social.link}
                                            sx={{
                                                display: 'inline-block',
                                                '&:hover': {
                                                    transform: 'scale(1.1)',
                                                    transition: 'transform 0.2s'
                                                }
                                            }}
                                        >
                                            <Box
                                                component="img"
                                                src={social.icon}
                                                alt={social.alt}
                                                sx={{
                                                    width: { xs: 32, md: 40 },
                                                    height: { xs: 32, md: 40 },
                                                    borderRadius: '8px'
                                                }}
                                            />
                                        </Box>
                                    ))}
                                </Stack>
                            </Box>
                        </Grid>

                        <Grid size={12} sx={{ mt: { xs: 3, md: 0 } }}>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: '#a0aec0',
                                    fontSize: { xs: '12px', md: '14px' },
                                    textAlign: { xs: 'left', md: 'left' }
                                }}
                            >
                                ©2025 MeetMyBot. All rights Reserved
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            <CookieConsent />
        </>
    );
}